import { Center } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';

export function NavigationHighlight() {
  return (
    <Center
      backgroundColor="orange.700"
      borderRadius="25px"
      marginLeft="space-8"
      paddingX="5px"
      paddingY="2px"
    >
      <SunshineIcon color="white" name="sparkle-single" size="icon-13" />
    </Center>
  );
}
